import getSmallestAllotmentCount from './getSmallestAllotmentCount'
import checkIfTravelClassIsSmart from './checkIfTravelClassIsSmart'

export default getSmallestAllotmentCount(checkIfTravelClassIsSmart)
